// extracted by mini-css-extract-plugin
export default {"containerBig":"MenuCards_containerBig__Ba37k","cards":"MenuCards_cards__cvgnk","description":"MenuCards_description__3+RdF"};